import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-straw",
  "use": "icon-straw-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-straw\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M11.24,7.54l1-1,1.31,1.3,2.09-2.08a.73.73,0,0,1,1,0l1.56,1.56a.73.73,0,0,1,0,1L16.2,10.41l1.3,1.31-1,1-1.05-1L8.63,18.5H5.5V15.37l6.78-6.78ZM8.05,17l6.32-6.32-1-1L7,16Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol